module.exports = __webpack_public_path__ + "img/DARV.ed9ecad5.jpg";